import { useEffect } from 'react';

import { useDisclosure } from 'Util/Hooks';

import { MATERIAL_TYPE, SCREEN_ORIENTATION, SUBSECTION_TYPE } from '../../constant';

const useFlutterToggleFullscreen = (props) => {
  const [isOpen, open, close, toggle] = useDisclosure(props);

  const handleFlutterMessage = (event) => {
    const message = JSON.parse(event.data);
    // Current subsection type is 'VIDEO_SLIDE' and the device is rotated to landscape.
    if (
      message.subsectionType === SUBSECTION_TYPE.VIDEO_SLIDE &&
      message.orientation === SCREEN_ORIENTATION.LANDSCAPE
    ) {
      open();
      return;
    }
    // Device rotated back to portrait, minimize the slide.
    const currentFullscreenContent = message.currentFullscreenContent;
    if (
      message.orientation === SCREEN_ORIENTATION.PORTRAIT &&
      // Prevent calling close() when the `VIDEO` is in fullscreen
      (currentFullscreenContent === MATERIAL_TYPE.SLIDES || currentFullscreenContent === 'NONE')
    ) {
      close();
      return;
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleFlutterMessage);
    return () => window.removeEventListener('message', handleFlutterMessage);
  }, []);

  const openAndToggleFullscreen = () => {
    open();
    window.flutter_inappwebview?.callHandler('handleFullscreenChange', {
      isFullscreen: true,
      currentFullscreenContent: MATERIAL_TYPE.SLIDES,
    });
  };

  const closeAndToggleFullscreen = () => {
    close();
    window.flutter_inappwebview?.callHandler('handleFullscreenChange', {
      isFullscreen: false,
      currentFullscreenContent: 'NONE',
    });
  };

  return [isOpen, openAndToggleFullscreen, closeAndToggleFullscreen, toggle];
};

export default useFlutterToggleFullscreen;
